import styled from "styled-components";

export const BadgesRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;

	${({ compact }) =>
		compact &&
		`
		gap: 8px;
	`}

	${({ align }) =>
		align === "center" &&
		`
		justify-content: center;
	`}
`;

export const BadgeLink = styled.a`
	display: flex;
	flex-direction: column;
	align-items: center;
	line-height: 0;
	opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};
	pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
	cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
	position: relative;
	gap: 6px;
	transition: transform 0.2s ease, opacity 0.2s ease;

	&:hover {
		transform: ${({ disabled }) => (disabled ? "none" : "scale(1.03)")};
	}
`;

export const ComingSoon = styled.span`
	background: #2572b5;
	color: #fff;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.02em;
	padding: 3px 6px;
	border-radius: 8px;
	white-space: nowrap;
	line-height: 1.2;
`;
